<!-- Specialities Section -->
<section class="specialities-section-one">
  <div class="container">
    <div class="row">
      <div class="col-md-6 aos" data-aos="fade-up" data-aos-duration="2000">
        <div class="section-header-one section-header-slider">
          <h2 class="section-title">{{ 'PORTAL.HOME.SPECIALTIES-SECTION.TITLE' | translate }}</h2>
        </div>
      </div>
      <div class="col-md-6 aos" data-aos="fade-up" data-aos-duration="2000">
        <div class="owl-nav slide-nav-1 text-end nav-control"></div>
      </div>
    </div>
    <div
      class="specialities-slider-one owl-theme aos"
      data-aos="fade-up"
      data-aos-duration="2000">
      <owl-carousel-o [options]="specialitiesSlider">
        @for (data of specialitiesList; track data) {
          <ng-template carouselSlide>
            <div class="item" (click)=onSearchBySpeciality(data.code)>
              <div class="specialities-item">
                <div class="specialities-img">
                  <span><img [src]="data.value" alt="heart-image" /></span>
                </div>
                <p>{{ data.label }}</p>
              </div>
            </div>
          </ng-template>
        }
      </owl-carousel-o>
    </div>
  </div>
</section>
<!-- /Specialities Section -->
